import axios from 'axios';
import { ApiError } from './error';

export function getMyConfig() {
    return axios
        .get('/api/v1/messaging-config/me')
        .then(res => res.data.data)
        .catch(ApiError.ofAndThrow);
}

export function createOrUpdateConfig(configData) {
    return axios
        .post('/api/v1/messaging-config', configData)
        .then(res => res.data.data)
        .catch(ApiError.ofAndThrow);
}

export function updateTemplates(templates) {
    return axios
        .post('/api/v1/messaging-config', { templates })
        .then(res => res.data.data)
        .catch(ApiError.ofAndThrow);
}

export function testConnection(platform, apiKey) {
    return axios
        .post('/api/v1/messaging-config/test-connection', { platform, apiKey })
        .then(res => res.data.data)
        .catch(ApiError.ofAndThrow);
}

export function initIntegration() {
    return axios
        .post('/api/v1/messaging-config/init-integration')
        .then(res => res.data.data)
        .catch(ApiError.ofAndThrow);
}
